import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { colors } from 'constants/colors';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  errorContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: colors.MAIN_GRAY,
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  errorTitle: {
    display: 'block',
    fontSize: '1.5rem',
    fontWeight: 500,
    marginBottom: '1rem',
    color: colors.BLUE,
    textAlign: 'center',
  },
} satisfies Record<string, StyleEntry>;
